import {Component, inject, signal} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {ArtworkService} from '@api-services';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {RouterLink} from '@angular/router';
import {ButtonComponent} from '@components';
import {ModalComponent} from '@easy-cms';
import {ArtworkDto} from '@api-contracts';
import {map} from 'rxjs';

@Component({
  selector: 'wun-artworks-table',
  standalone: true,
  imports: [
    CurrencyPipe,
    DatePipe,
    RouterLink,
    ButtonComponent,
    ModalComponent
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class ArtworksTableComponent {

  private readonly artworkService = inject(ArtworkService);

  showDeleteModal = signal(false);
  selectedArtwork = signal<ArtworkDto | undefined>(undefined);

  artworks = rxResource({
    stream: () => this.artworkService.artworksFindAndPaginate({
      includes: JSON.stringify(['mainAttachment', 'artist']),
      pageSize: 1000,
      sorting: JSON.stringify({createdAt: 'DESC'})
    }).pipe(
      map(response => ({
        ...response,
        data: [...(response.data ?? [])].sort((a, b) => {
          const aIsNew = a.status === ArtworkDto.StatusEnum.Created ? 0 : 1;
          const bIsNew = b.status === ArtworkDto.StatusEnum.Created ? 0 : 1;
          return aIsNew - bIsNew;
        })
      }))
    )
  });

  cancelDelete() {
    this.showDeleteModal.set(false);
    this.selectedArtwork.set(undefined);
  }

  deleteArtwork() {
    this.artworkService.artworksDelete({
      id: this.selectedArtwork()!.id
    }).subscribe(() => {
      this.artworks.reload();
      this.showDeleteModal.set(false);
    });
  }
}
